<template>
<div id='addressEditor'>

	<div v-if='ade_show !== 0' :class="{'ade-mask':true, 'ade-mask-close':ade_show === 2}" @click='vade_close'></div>
	<div :class="{'ade-model':true, 'ade-model-show':ade_show===1}">
		<!-- 视觉区域 -->
		<div class='ade-model-visual' @click='vade_close'>
			<!-- 绳索 -->
			<div v-for='item in 4' :key='item' class='ade-model-visual-layout'>
				<div class='ade-model-visual-layo-view01'><div v-for='item in 2' :key='item' class='ade-model-visual-layo-view01-line'></div></div>
				<div class='ade-model-visual-layo-view02'></div>
			</div>
			<div class='ade-model-visual-layout2'></div>
		</div>
		<!-- 面板 -->
		<div class='ade-model-plate'>
			<!-- 面板-首行 -->
			<div class='ade-model-plate-title no-copy'>
				<div class='fontcolor-16 fontweight-bo'>编辑地址</div>
				<div class='ade-model-plate-tit-right'>
					<div class='ade-model-plate-tit-rig-btn font-12 bgcolor' @click='vade_save'>保存</div>
					<div class='ade-model-plate-tit-rig-btn ade-model-plate-tit-rig-btn-no font-12'
						 @click='vade_close'>取消
					</div>
				</div>
			</div>
			<div v-for='item in ade_list' :key='item.id' class='ade-model-plate-line font-14'>
				<div :class="{'ade-model-plate-line-name':true, 'color-prompt':!item.canModify}">{{item.name}}</div>
				<v-distpicker v-if="item.value.constructor['name']==='Array'" 
							  wrapper='ade-model-plate-line-picker' 
							  :province="ade_list[3]['value'][0]" 
							  :city="ade_list[3]['value'][1]" 
							  :area="ade_list[3]['value'][2]" 
							  @selected='func_distpicker' 
							  >
				</v-distpicker>
				<input v-else-if='item.canModify' class='ade-model-plate-line-input' :placeholder="item.prompt ? item.prompt : ''" v-model='item.value' />
				<div v-else class='ade-model-plate-line-onlineShow color-prompt'>{{item.value}}</div>
			</div>
		</div>
	</div>

</div>
</template>
<script>
export default {
	name: 'addressEditor',
	props: {},
	data() {
		return {
			ade_show: 0,
			ade_list: [
				{id:'adel01', canModify:true,  name:'收货人', value:'', prompt:''},
				{id:'adel02', canModify:true,  name:'联系电话', value:'', prompt:''},
				{id:'adel03', canModify:true,  name:'收货公司', value:'', prompt:''},
				{id:'adel06', canModify:true,  name:'收货地区', value:['', '', ''], prompt:''},
				{id:'adel04', canModify:true,  name:'收货地址', value:'', prompt:'详细地址'},
				{id:'adel05', canModify:false, name:'是否默认', value:'否'},
			],
		}
	},
	methods: {
		// show方法
		vade_Change(address_info) {
			this.ade_list[0]['value'] = address_info['rsrvstr1'];
			this.ade_list[1]['value'] = address_info['rsrvstr4'];
			this.ade_list[2]['value'] = address_info['rsrvstr2'];
			this.ade_list[3]['value'] = [
				address_info['province'],
				address_info['city'],
				address_info['area']
			];
			this.ade_list[4]['value'] = address_info['address'];
			this.ade_list[5]['value'] = (address_info['isdefault'] === 1 ? '是' : '否');
			this.ade_show = 1;
		},
		// close方法
		vade_close() {
			this.ade_show = 2;
			setTimeout(() => {
				this.ade_show = 0;
			}, 200)
		},
		// 地区选择触发器
		func_distpicker(event) {
			this.ade_list[3]['value'] = [
				event['province']['code'] ? event['province']['value'] : '',
				event['city']['code'] ? event['city']['value'] : '',
				event['area']['code'] ? event['area']['value'] : '',
			];
		},
		// 保存
		vade_save() {
			for (let i in this.ade_list) {
				if (this.ade_list[i]['id']!=='adel06' && (!this.ade_list[i]['value'] || this.ade_list[i]['value'].length < 1)) {
					this.$parent.$parent.msgChange('warning', '请填写'+this.ade_list[i]['name'], '');
					return;
				} else if (this.ade_list[i]['id'] === 'adel06') {
					for (let j in this.ade_list[i]['value']) {
						if (!this.ade_list[i]['value'][j] || this.ade_list[i]['value'][j].length < 1) {
							this.$parent.$parent.msgChange('warning', '请补充完整地区', '');
							return;
						}
					}
				}
			}

			this.$parent.func_editorAddress({
				Address: this.ade_list[4]['value'],
				province: this.ade_list[3]['value'][0],
				city: this.ade_list[3]['value'][1],
				area: this.ade_list[3]['value'][2],
				name: this.ade_list[0]['value'],
				company: this.ade_list[2]['value'],
				phone: this.ade_list[1]['value'],
			});
			this.vade_close();
		}
	},
	mounted() {
	}
}
</script>
<style scoped>

.ade-mask {
	background:rgba(0, 0, 0, 0);
	width:100%; height:100vh;
	position:fixed; top:0; left:0;
	animation: adeMaskShow 0.2s linear 0s forwards;
}
@keyframes adeMaskShow
{
	from {background:rgba(0, 0, 0, 0);}
	to {background:rgba(0, 0, 0, 0.5);}
}
.ade-mask-close {
	animation: adeMaskClose 0.2s linear 0s forwards;
}
@keyframes adeMaskClose
{
	from {background:rgba(0, 0, 0, 0.5);}
	to {background:rgba(0, 0, 0, 0);}
}

.ade-model {
	display:flex; flex-direction:column; align-items:center;
	position:fixed; top:0; left:calc((100% - 500px)/2);
	transform: translateY(-102%);
	transition: all 0.5s ease-in-out 0s;
}
.ade-model-show {
	transform: translateY(-0%);
}

.ade-model-visual {
	height:200px;
	overflow:hidden;
}
.ade-model-visual-layout {
display:flex; flex-direction:column; align-items:center;
}
.ade-model-visual-layo-view01 {
	width:20px; height:26px;
	display:inline-flex; justify-content:space-between; align-items:center;
}
.ade-model-visual-layo-view01-line {
	background:rgba(255, 255, 255, 0.9);
	width:6px; height:100%;
	border-radius:10px;
}
.ade-model-visual-layo-view02 {
	background:rgba(255, 255, 255, 0.9);
	width:6px; height:20px;
	border-radius:10px;
}
.ade-model-visual-layout2 {
	background:rgba(255, 255, 255, 1);
	width:160px; height:16px;
	transform: scaleY(1.3) perspective(.4em) rotateX(5deg);
	transform-origin: bottom;
}

.ade-model-plate {
	background:rgba(255, 255, 255, 1);
	width:500px;
	box-sizing:border-box; padding:0 20px;
	border-radius:10px;
	box-shadow:0 0 4px #aaaaaa;
}
.ade-model-plate-title {
	width:100%;
	padding:16px 0;
	display:flex; flex-wrap:wrap; justify-content:space-between;
}
.ade-model-plate-tit-right {
	display:inline-flex; flex-wrap:wrap; align-items:center;
}
.ade-model-plate-tit-rig-btn {
	color:#ffffff; margin:0 0 0 4px;
	box-sizing:border-box; padding:4px 10px;
	border-radius:4px; border:1px solid #eeeeee;
	cursor:pointer;
}
.ade-model-plate-tit-rig-btn:active {
	opacity:0.8;
}
.ade-model-plate-tit-rig-btn-no {
	background:#aaaaaa;
}
.ade-model-plate-line {
	width:100%; margin:10px 0;
	display:flex; align-items:center;
}
.ade-model-plate-line-name {
	width:76px;
}
.ade-model-plate-line-input {
	width:calc(100% - 76px); height:26px;
	border-radius:0; border-width:0 0 1px 0; border-style:solid; border-color:#cccccc;
}
.ade-model-plate-line-onlineShow {
	width:calc(100% - 76px); height:26px;
	display:inline-flex; align-items:center;
	box-sizing:border-box; padding:0 11px;
}
.ade-model-plate-line-picker {
	width:calc(100% - 76px); height:26px;
	box-sizing:border-box; padding-left:11px;
	border-width:0 0 1px 0; border-style:solid; border-color:#cccccc;
}
</style>




// WEBPACK FOOTER //
// src/components/address/addressEditor.vue